<script>
  // TODO: clean up filter

  import { setContext, createEventDispatcher, onMount } from "svelte";
  import FilterText from "../form/FilterText.svelte";
  import CheckboxGroup from "../form/CheckboxGroup.svelte";
  import DatePicker from "../form/FilterDatePicker.svelte";
  import SingleCheckbox from "../form/SingleCheckbox.svelte";
  import Select from "svelte-select";
  import InputWrapper from "../form/InputWrapper.svelte";
  import AutoCompleteCombo from "../form/AutoCompleteCombo.svelte";
  import SelectInput from "../form/SelectInput.svelte";
  const dispatch = createEventDispatcher();

  export let filters = [];

  let data = {};
  let detail = {};
  function onFormChange(e) {}

  const handleComboChange = (name, valueArray) => {
    let values = [];
    values = valueArray?.map((item) => item.value);
    handleFilterChange(name, values);
  };

  const handleFilterChange = (name, value) => {
    if (data[name] == value) return;
    // delete from filter if cleared
    if (value == undefined || value == null) {
      delete data[name];
    } else {
      // set value to filter
      data[name] = value;
    }
    detail = {
      filter: data,
    };
    dispatch("filterChange", detail);
  };

  function updateFilterKey(key, newKey) {
    data = {};
    filters = filters.map((filter) => {
      if (filter.key === key) {
        let val = "";
        const filterTextElement = document.querySelector(
          `input[name="${key}"]`
        );
        if (filterTextElement) {
          val = filterTextElement.value;
        }
        // replacing existing search filter
        delete data[key];
        data[newKey] = val;
        return {
          ...filter,
          key: newKey,
          value: val,
        };
      }
      return filter;
    });
    // update new filter
    detail.filter = data;
    data[newKey] && dispatch("filterChange", detail);
  }

  function handleDateChange(event, name) {
    const dateFilterKey = filters.find((f) => f.filter == "date").key;
    data[dateFilterKey] = data[dateFilterKey] || {};
    const newDate = event.detail
      ? new Date(event.detail).toISOString()
      : undefined;
    if (data[dateFilterKey][name] == newDate) return;
    data[dateFilterKey][name] = newDate;

    const detail = {
      filter: data,
    };
    dispatch("filterChange", detail);
  }

  setContext("form", { onFormChange });

  // the Select component doesn't call onselect for initial values
  // call that to make it same as other components here
  onMount(async () => {
    const listFilter = filters.find((f) => f.filter == "list");
    if (listFilter) {
      handleFilterChange(listFilter.key, listFilter.value);
    }
  });
</script>

<div class="w-full">
  <form class="w-full flex flex-row gap-2">
    {#each filters as col}
      {#if col.filter}
        {#if col.filter === "text"}
          {#if col.options?.length}
            <div class="w-56 z-100">
              <SelectInput
                isClearable={false}
                name="search_options"
                isSearchable={false}
                containerStyles=""
                containerClasses="inline-block focus:ring-yellow-500 focus:border-yellow-500 shadow-sm w-80 h-10 sm:text-sm border-gray-300 rounded-md"
                placeholder="Search By"
                value={col.key}
                on:change={(e) => updateFilterKey(col.key, e.detail.value)}
                items={col.options}
              />
            </div>
          {/if}
          <div class="w-56">
            <FilterText
              cssClass="h-10"
              type="search"
              label={col.label}
              name={col.key}
              on:onChange={(e) =>
                handleFilterChange(col.key, e.detail.target.value)}
              value={col.value}
              initialValue={col.value}
            />
          </div>
        {/if}
        {#if col.filter === "number"}
          <div class="w-56">
            <FilterText
              type="number"
              label={col.label}
              name={col.key}
              on:onChange={(e) =>
                handleFilterChange(col.key, e.detail.target.value)}
              value={col.value}
              initialValue={col.value}
            />
          </div>
        {/if}
        {#if col.filter === "checkbox"}
          <div class="inline-block">
            <CheckboxGroup
              label={col.label}
              name={col.key}
              options={col.options}
              values={col.default}
            />
          </div>
        {/if}
        {#if col.filter === "boolean"}
          <div class="inline-flex self-center">
            <SingleCheckbox
              label={col.label}
              value={filters[col.key]}
              on:onChange={(e) =>
                handleFilterChange(col.key, e.detail.target.checked)}
            />
          </div>
        {/if}
        {#if col.filter == "list"}
          <div class="flex flex-col w-full justify-center z-100">
            <div>{col.label}</div>
            <div
              class="inline-block focus:ring-yellow-500 focus:border-yellow-500 shadow-sm w-80 h-12 sm:text-sm border-gray-300 rounded-md"
            >
              {#await col?.getItems()}
                <Select
                  items={[]}
                  placeholderAlwaysShow={`select-${col.key}`}
                  on:change={(e) => handleFilterChange(col.key, e.detail.value)}
                  isWaiting={true}
                  placeholder="Loading"
                  multiple
                />
              {:then items}
                <Select
                  {items}
                  placeholder={`select-${col.key}`}
                  on:change={(e) => handleFilterChange(col.key, e.detail.value)}
                  value={col.value}
                  loadOptions={col.getItems}
                />
              {/await}
            </div>
          </div>
        {/if}
        {#if col.filter === "date"}
          <span class="whitespace-nowrap w-full">
            <div class="inline-block mr-2">
              <DatePicker
                label={col.label}
                name={`${col.key}{from}`}
                reset={col.resetFilter}
                value={col.value?.from || ""}
                on:onChange={(e) => handleDateChange(e, "from")}
              />
            </div>
            <div class="inline-block">
              <DatePicker
                label=""
                name={`${col.key}{to}`}
                on:onChange={(e) => handleDateChange(e, "to")}
                value={col.value?.to || ""}
              />
            </div>
          </span>
        {/if}
        {#if col.filter === "date_single"}
          <div class="inline-block">
            <DatePicker
              label={col.label}
              name={`${col.key}`}
              reset={col.resetFilter}
              value={col.value}
              on:onChange={(e) => handleFilterChange(col.key, e.detail)}
            />
          </div>
        {/if}
        {#if col.filter === "combo"}
          <div class="flex flex-row gap-2">
            <div class="w-72 z-100">
              <SelectInput
                isClearable={col.clearable || false}
                name={col.key}
                isMulti={col.multi || false}
                isSearchable={false}
                containerStyles=""
                closeListOnChange={false}
                containerClasses="inline-block focus:ring-yellow-500 focus:border-yellow-500 shadow-sm w-80 h-10 sm:text-sm border-gray-300 rounded-md"
                placeholder={col.label}
                on:change={(e)=>handleComboChange(col.key, e.detail)}
                items={col.options}
              />
            </div>
          </div>
        {/if}
      {/if}
    {/each}
    {#if filters}
      <slot />
    {/if}
  </form>
</div>
